import { Component, ViewChild } from '@angular/core';
import { DMApiService } from '../../API/dmapi.service';
import { TableHeadsService } from '../../Core/tableheads.service';
import { IMyDateModel, IAngularMyDpOptions } from 'angular-mydatepicker';
import { Router } from '@angular/router';
import { PageHeaderComponent } from '../../Core/pageheader.component';
import { AppComponent } from '../../app.component';
import { Globals } from '../../globals';
import { CommonApiService } from 'src/app/API/commonapi.service.';
import { AuthService } from 'src/app/API/auth.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'DMHourSearch',
  templateUrl: './DMHourSearch.component.html'
})
export class DMHourSearchComponent {
  UserList: any;
  constructor(
    private dmapi: DMApiService,
    private router: Router,
    private dataGridService: TableHeadsService,
    private commonapi: CommonApiService,
    private auth: AuthService
  ) {
    this.page.pageNumber = 0;
    this.page.size = 25;
  }

  @ViewChild(PageHeaderComponent, { static: true })
  pageheader: PageHeaderComponent;
  loading = true;
  DialysisUnits = [];
  Equipments = [];
  selectedEquipment = '';
  selectedDivision = 'All Divisions';
  EventId = '';
  blnDirtySearch = false;
  FromDate;
  ToDate;
  tableHeaders;
  page = new Page();
  rows;
  AddUrl = 'DialysisMachine/DMHoursUpdateDetail';
  currentPageNumber = 1;
  sortExpression = 'dmhoursupdatedate';
  sortDirection = 'DESC';
  pageSize = 25;
  ShowSearch = false;
  title = 'DM Hours';
  searchText = 'Search Records';
  defaultSort;

  // tslint:disable-next-line:member-ordering
  public myOptions: IAngularMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
    closeSelectorOnDateSelect: false,
    disableSince: { year:  new Date().getFullYear(), month:  new Date().getMonth() + 1, day:  new Date().getDate() + 1 }
  };

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit() {
    this.auth.GetCurrentUserDivision().subscribe(division => {

      this.dataGridService.clearHeader();
      this.dataGridService.addHeader('#', 'eventcode', '4');
      this.dataGridService.addHeader('Event Code', 'eventcode', '12');
      this.dataGridService.addHeader('Event Date', 'dmhoursupdatedate', '12');
      this.dataGridService.addHeader('Division Name', 'divisionname', '22');
      this.dataGridService.addHeader('Dialysis Machine', 'equipmentname', '20');
      this.dataGridService.addHeader('Hours', 'dialysismachinehours', '12');
      this.dataGridService.addHeader('Technologist', 'createdByName', '17');

      this.sortDirection = 'DESC';
      this.sortExpression = 'dmhoursupdatedate';
      this.tableHeaders = this.dataGridService.setTableHeaders();
      this.defaultSort = this.dataGridService.setDefaultSort('Event Date', true);
      // this.fillSiloes();
      if (division.length === 1)
        this.fillDialysisUnit(division[0]);
      else
        this.fillDialysisUnit();

      this.fillEquipment();
      this.CheckDirtySearch();
    }, error => {
      AppComponent.addAlert(error.message, 'error');
      AppComponent.HideLoader();
    });
  }

  onSearchShowChange(value) {
    this.ShowSearch = value;
  }

  changeSorting(column) {
    if (column === '#') {
      return;
    }

    this.dataGridService.changeSorting(
      column,
      this.defaultSort,
      this.tableHeaders
    );
    this.defaultSort = this.dataGridService.getSort();
    this.sortDirection = this.dataGridService.getSortDirection();
    this.sortExpression = this.dataGridService.getSortExpression();
    this.currentPageNumber = 1;
    this.page.pageNumber = 1;
    this.executeDMHourSearch();
  }

  fillEquipment() {
    this.dmapi.GetEquipmentDD(0).subscribe(list => this.Equipments = list);

  }

  setSortIndicator = function (column) {
    //  console.log(this.dataGridService.setSortIndicator(column, this.defaultSort));
    return this.dataGridService.setSortIndicator(column, this.defaultSort);
  };

  executeDMHourSearch() {
    AppComponent.ShowLoader();
    this.pageheader.isSearchOpen = false;
    this.pageheader.searchText = 'Search Records';
    this.ShowSearch = false;
    this.searchText = 'Search Records';
    this.CheckDirtySearch();
    const DMHourSearch = this.prepareSearch();
    this.dmapi.GetDMHoursUpdateRecords(DMHourSearch).subscribe(
      pagedData => {
        // console.log(pagedData);
        this.page.totalElements = pagedData.totalRows;
        this.page.totalPages = pagedData.totalPages;
        this.rows = pagedData.dmHoursUpdateDetails;
        AppComponent.HideLoader();
      },
      error => {
        AppComponent.addAlert(error.message, 'error');
        AppComponent.HideLoader();
      }
    );
  }

  prepareSearch() {
    const DMHourSearch = <any>{};

    DMHourSearch.eventCode = this.EventId;

    if (this.FromDate !== undefined && this.FromDate !== '') {
      DMHourSearch.fromdate = Globals.GetAPIDate(this.FromDate.singleDate.jsDate);
    }

    if (this.ToDate !== undefined && this.ToDate !== '') {
      DMHourSearch.todate = Globals.GetAPIDate(this.ToDate.singleDate.jsDate);
    }

    if (this.selectedDivision !== undefined && this.selectedDivision !== '' && this.selectedDivision !== '0' && this.selectedDivision !== 'All Divisions') {
      DMHourSearch.division = this.selectedDivision;
    }

    if (this.selectedEquipment !== undefined && this.selectedEquipment !== '') {
      DMHourSearch.equipmentid = this.selectedEquipment;
    }

    DMHourSearch.currentPageNumber = this.currentPageNumber;
    DMHourSearch.sortExpression = this.sortExpression;
    DMHourSearch.sortDirection = this.sortDirection;
    DMHourSearch.pageSize = this.pageSize;
    // console.log(DMHourSearch);
    return DMHourSearch;
  }

  setPage() {
    this.currentPageNumber = this.page.pageNumber;
    this.executeDMHourSearch();
  }
  _onRowClick(row) {
    this.router.navigate([this.AddUrl], { queryParams: { id: row } });
  }

  onDateChanged(event: IMyDateModel): void {
    // date selected
  }

  fillDialysisUnit(defaultValue = '') {
    this.commonapi.FillDivision(true).subscribe(list => {

      if(Globals.Website == 'UHN')
      {
        this.DialysisUnits = list;
      }
      else
      {
        this.DialysisUnits = list;
        // this.DialysisUnits = list.filter(
        //   x => x.text != "Home Program"
        // );
      }

      if (defaultValue) {
        let defaultVal = list.filter(
          x => x.value == defaultValue
        );

        if (defaultVal && defaultVal.length > 0 && defaultVal[0]) {
          this.selectedDivision = defaultVal[0].text;
          setTimeout(() => this.executeDMHourSearch());
        }
      }
    });
  }

  fillUserList() {
    this.dmapi
      .GetUsersDD()
      .subscribe(list => (this.UserList = list));
  }

  executeDMHourSearchClear() {
    this.selectedDivision = 'All Divisions';
    this.EventId = '';
    this.FromDate = '';
    this.ToDate = '';
    this.selectedEquipment = '';
    this.executeDMHourSearch();
  }

  CheckDirtySearch() {
    this.blnDirtySearch = false;

    if (
      (this.selectedDivision &&  this.selectedDivision != "All Divisions") ||
      this.selectedEquipment ||
      this.EventId ||
      this.FromDate ||
      this.ToDate
    ) {
      this.blnDirtySearch = true;
    }
    return this.blnDirtySearch;
  }

  CheckFormDate(fdate, edate) {
    return this.commonapi.CompareDates(fdate, edate);
  }

  DialysisUnitDropDownChanged() {
    this.executeDMHourSearch();
  }
  
  hideSearch() {
     this.ShowSearch = false;
  }
}

export class Page {
  // The number of elements in the page
  size = 0;
  // The total number of elements
  totalElements = 0;
  // The total number of pages
  totalPages = 0;
  // The current page number
  pageNumber = 0;
}
